import type { IProspectAccount } from "@apis/prospects/types"
import { Button } from "@components/ui/button"
import type { ColumnDef } from "@tanstack/react-table"
import { DateCell } from "@utils/table/columnFactories"
import { Link } from "react-router-dom"

export const prospectAccountsColumns = (
  prospect_guid: string,
): ColumnDef<IProspectAccount>[] => {
  return [
    { header: "Product", accessorKey: "product_type_code" },
    { header: "Utility", accessorKey: "market_code" },
    {
      header: "Account Identifier",
      cell: ({ row }) => (
        <Button variant="link">
          <Link
            to={`/profiles/${prospect_guid}/accounts/${row.original.account_id}`}
          >
            {row.original.account_number}
          </Link>
        </Button>
      ),
    },
    { header: "Service Address", accessorKey: "service_address" },
    { header: "Status", accessorKey: "status_group" },
    {
      accessorKey: "sale_dt",
      header: "Sold",
      cell: (props) => <DateCell {...props} />,
    },
  ]
}
